'use client';
import React from 'react';
import { Button, Div, Media } from '@pezeshk-book/ui-kit';
import { MessagesActions } from '@store/client/messages/messages-actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import MessagesList from './sub-components/messages-list';
import InfiniteScrollLayout from '../../../components/infinit-scroll-layout';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const MessagesLayout = () => {
  const dispatch = useDispatch();
  const { list, currentPage, lastPage } = useSelector((state: RootState) => state.messages);
  const { lang } = useParams<{ lang : LocaleTypes }>();
  const { dashboard: { messages } } = getDictionary(lang);

  const handleMessagesPagination = () => {
    dispatch(MessagesActions.getExtendedMessagesList());
  };

  const handleReadAll = () => {
    const markAsRead = list.map((value : {id: string}) => value.id);
    dispatch(MessagesActions.setMessagesAsRead({ ids: markAsRead }));
  };
  return (
    <InfiniteScrollLayout
      next={handleMessagesPagination}
      hasMore={lastPage >= currentPage}
      length={list.length}
    >
      <Div className={'w-full flex-col gap-4'}>
        <Media className={'w-full'} greaterThan={'sm'}>
          <Button variant={'text'} className={'self-end !px-0'} disabled={list.length && list.every((value: any) => !!value.read_at)} onClick={handleReadAll}>
            {messages.buttons.read_list}
          </Button>
        </Media>
        <MessagesList />
        <Media lessThan={'md'}>
          <Div className={'z-10 w-full left-0 bottom-0 p-3 md:p-0 bg-white duration-500 justify-center items-center fixed md:static shadow-2xl shadow-black md:shadow-none'}>
            <Button className={'w-full'} disabled={list.length && list.every((value: any) => !!value.read_at)} onClick={handleReadAll}>
              {messages.buttons.read_list}
            </Button>
          </Div>
        </Media>
      </Div>
    </InfiniteScrollLayout>
  );
};

export default MessagesLayout;
